export default (props, vars) =>
  props?.['student']?.photo ? `url(${props?.['student'].photo})` : undefined;
